import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { useSettingsContext } from "../Settings/hooks/useSettingsContext";
import { useInvoicesDetail } from "./hooks/useInvoiceDetail";
import { InvoicesTypes } from "./types/invoices";
import { LoadingAnimation } from "../LoadingAnimation";
import { useTranslation } from "react-i18next";

const InvoicesDownload = () => {
  const Settings = useSettingsContext();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();

  const [invoiceType, _setInvoiceType] = useState<InvoicesTypes>(
    (searchParams.get("contractType") as InvoicesTypes) ?? Settings.features.displayTypes[0]
  );

  const { handleDownload } = useInvoicesDetail({invoiceId: Number(id)});

  const download = async () => {
    await handleDownload({ type: invoiceType, option: "pdf", historic: false });
    navigate(t('common:url.invoices'));
  };

  useEffect(() => {
    if (!Number.isNaN(Number(id))) {
      download();
    }
  }, [])

  return (
    <LoadingAnimation/>
  )

}

export default InvoicesDownload